import React from "react"
import { LoginBgArray, actionObjLocalReducer, InputFieldState } from "../const"
import { selectRandomFromArray, sanitizeHTML, userFieldExistance, login } from "../functions"
import { validateEmail, validatePassword } from "../validations"
import InputField from "./stateless/InputField"
import BackgroundWithImage from "./BackgroundWithImage"
import { useGlobalContext } from "../context"
import { Link, useHistory } from "react-router-dom"

function localReducer(state: InputFieldState, action: actionObjLocalReducer) {
    // console.log(state, action)
    const newState = { ...state }
    switch (action.type) {
        case "set-error":
            newState[action.payload[0]].err = action.payload[1]
            newState[action.payload[0]].val = ""
            return newState
        case "remove-error":
            newState[action.payload].err = ""
            return newState
        case "set-value":
            newState[action.payload[0]].err = ""
            newState[action.payload[0]].val = sanitizeHTML(action.payload[1])
            return newState

        case "set-validationFn":
            newState[action.payload[0]].validationFn = action.payload[1]
            return newState

        default:
            return state
    }
}

const Login = () => {
    const history = useHistory()
    const { globalState, dispatch, log, t } = useGlobalContext()
    const [error, setError] = React.useState("")
    const [localState, localDispatch] = React.useReducer(localReducer, {
        password: { val: "", err: "", required: true, validationFn: validatePassword },
        email: { val: "", err: "", required: true, validationFn: validateEmail },
    })
 
 React.useEffect( () => {
     if(globalState.authorized) {
         const lastMemberPage = globalState.urls.find(item=> /user/gi.test(item))
         if(lastMemberPage) history.push(lastMemberPage)
     }
 }, [])


    React.useEffect(() => {
        // console.log("localState::: ", localState)
        if (!localState.email.val) return
        userFieldExistance({ field: "email", value: localState.email.val }).then((res) => {
            // isMounted.current && console.log(">>>> userFieldExistance <<<" ,localState.email.val ,localState.email.val  === "mehdibeethoven@gmail.com",  res)
            if (!res /* &&  isMounted.current*/) localDispatch({ type: "set-error", payload: ["email", "No account with this email!"] })
        })
    }, [localState.email.val])

    const submitHandler = async (e: React.FormEvent) => {
        e.preventDefault()
        // console.log(localState)

        const hasError = Object.entries(localState)
            .map(([key, value]) => {
                if (value.required && value.err) return key
                else if (value.required && !value.val) {
                    localDispatch({ type: "set-error", payload: [key, "Cannot be empty!"] })
                    return key
                }
                return ""
            })
            .filter((item) => Object.keys(localState).includes(item))

        if (hasError.length) return

        await login({ email: localState.email.val, password: localState.password.val }).then((res) => {
            // console.log("-------------", localState.email.val, localState.password.val, res, t(res.error), history)
            if (res.error) return setError(t(res.error))
            else if (res.authorized && res.approved) {
                dispatch({ type: "set-user", payload: res })
                return history.push(`/${res.lang}/user/dashboard`)
            }
        })
    }

    return (
        <div className="login">
            <BackgroundWithImage bgUrl={selectRandomFromArray(LoginBgArray)}>
                <div className="content">

                    <form onSubmit={submitHandler}>
                    {globalState.error && <p>{t(globalState.error)}</p>}
                        <InputField field="email" label="Email" state={localState} dispatch={localDispatch} />
                        <InputField field="password" label="Password" type="password" state={localState} dispatch={localDispatch} />

                        <div className="button-area">
                            {error && <p>{error}</p>}
                            <button type="submit">Login</button>
                            <br />
                            <Link to="./reset_password" className="button-like">
                                Reset Password
                            </Link>
                        </div>
                    </form>
                </div>
            </BackgroundWithImage>
        </div>
    )
}

const ResetPassword = () => {
    const { globalState, dispatch, t, log } = useGlobalContext()
    const [localState, localDispatch] = React.useReducer(localReducer, {
        email: { val: "", err: "", required: true, validationFn: validateEmail },
    })

    return (
        <div className="login">
            <BackgroundWithImage bgUrl={selectRandomFromArray(LoginBgArray)}>
                <div className="content">
                    <form>
                        <InputField field="email" label="Email" state={localState} dispatch={localDispatch} />

                        <div className="button-area">
                            <button>Reset Password</button>
                            <br />
                            <Link to="/" className="button-like">
                                Back to login
                            </Link>
                        </div>
                        <p className="svg dim">An email with a link to reset your password will be sent to you.</p>
                    </form>
                </div>
            </BackgroundWithImage>
        </div>
    )
}

export { Login, ResetPassword }